import React, { useEffect, useMemo, useState, useRef } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import CommonTable from "../../components/CommonTable/CommonTable";
import { FaTimes, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import "./Admin.css";
import { deletes, get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import { toast } from "react-toastify";
import usePermission from "../../customHook/usePermission";

const Admin = () => {
  const location = useLocation();
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(location?.state?.page || 1);
  const [totalCount, setTotalCount] = useState();
  const [pagination, setPagination] = useState(null);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedFAQ, setSelectedFAQ] = useState(null);
  const pageRef = useRef(page);
  const preSearchPageRef = useRef(page);

  const user_id = localStorage.getItem("userId");

  const permission = usePermission();

  // keep pageRef in sync with the latest page
  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  // clear state after using it (run only once when component mounts)
  useEffect(() => {
    if (location?.state?.page) {
      // clear state after using it
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);

  // Define table columns using useMemo with Cell renderers
  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "sno",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <span className="sno">
              {String(row.index + 1 + (page - 1) * 10).padStart(2, "0")}
            </span>
          );
        },
      },
      {
        Header: "Admin ID",
        accessor: "admin_code",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
      {
        Header: "Admin Name",
        accessor: "name",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
      {
        Header: "Role",
        accessor: "role_name",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
      {
        Header: "Mobile Number",
        accessor: "mobile",
        disableSortBy: true,
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          if (user_id) {
            var ids = JSON.parse(user_id)?.id;
            console.log("id-->", ids);
          }

          const getStatusClass = (status) => {
            if (status === 1) return "status-active";
            if (status === 0) return "status-inactive";
            return "";
          };

          return (
            <>
              {ids != row?.original?.id &&
                permission?.includes("CAN-STATUS-ADMIN_LIST") && (
                  <span
                    className={`status-badge ${getStatusClass(value)}`}
                    onClick={() => handleStatusChange(row.original)}
                  >
                    {value === 1 ? "Active" : "Inactive"}
                  </span>
                )}
            </>
          );
        },
      },
    ];

    let action = {
      Header: "Action",
      accessor: "action",
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <div style={{ display: "flex", gap: "10px" }}>
            {permission?.includes("CAN-VIEW-ADMIN_LIST") && (
              <button
                className="action-btn"
                onClick={() => handleView(row.original)}
              >
                <FaEye />
              </button>
            )}
            {permission?.includes("CAN-EDIT-ADMIN_LIST") && (
              <button
                className="action-btn"
                onClick={() => handleEdit(row.original)}
              >
                <FaEdit />
              </button>
            )}
            {permission?.includes("CAN-DELETE-ADMIN_LIST") && (
              <button
                className="action-btn"
                onClick={() => handleDelete(row.original)}
              >
                <FaTrash color="Red" />
              </button>
            )}
          </div>
        );
      },
    };

    return [...d, action];
  }, [page]);

  const handleView = (row) => {
    navigate("/add-admin", {
      state: { data: row, mode: "view", page: pageRef.current },
    });
  };
  const handleEdit = (row) => {
    navigate("/add-admin", {
      state: { data: row, mode: "edit", page: pageRef.current },
    });
  };

  const handleClearSearch = () => {
    setSearchText("");
    setPage(preSearchPageRef.current || 1);
  };

  const fetch = async () => {
    let url = `${URLS.ADMINURL}?search=${searchText || ""}`;
    if (!searchText) {
      url += `&page=${page || 1}`;
    }
    let res = await get(url);
    console.log("Admin list res:", res);
    if (res?.status === "success") {
      setData(res?.data || []);
      setTotalCount(res?.count || 0);
      setPagination({
        current_page: res?.current_page || 1,
        last_page: res?.total_pages || 1,
      });
    }
  };

  useEffect(() => {
    fetch();
  }, [page, searchText]);

  console.log("AdminViewdata", data);

  const handleStatusChange = async (row) => {
    try {
      if (!row?.id) return;
      let res = await put(`${URLS.ADMINURL}${row.id}/status/`, {
        status: row.status === 1 ? 0 : 1,
      });
      console.log("User status res:", res);
      if (res?.status === "success") {
        fetch();
      }
    } catch (error) {
      console.error("Error updating user status:", error);
    }
  };
  const confirmDelete = async () => {
    try {
      if (selectedFAQ?.id) {
        let res = await deletes(URLS.ADMINURL + selectedFAQ.id + "/");
        if (res?.status === "success") {
          toast.success(res?.message || "Deleted successfully");
          fetch();
        } else {
          toast.error(res?.message || "Failed to delete");
        }
        setIsDeleteModalOpen(false);
        setSelectedFAQ(null);
      }
    } catch (error) {
      console.error("Error deleting FAQ:", error);
      toast.error(error?.message || "An error occurred");
    }
  };
  const handleDelete = (row) => {
    if (!row) return;
    setSelectedFAQ(row);
    setIsDeleteModalOpen(true);
  };
  return (
    <div>
      <PageHeader
        title="Admin"
        buttonText="+Add Admin"
        buttonPath="/add-admin"
        permissionAllowed={"CAN-ADD-ADMIN_LIST"}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#7a52ab" }}>
          Total: {totalCount || 0}
        </h2>
        <div className="search-wrapper">
          <input
            type="text"
            placeholder="Search"
            className="search-input"
            value={searchText || ""}
            onChange={(e) => {
              const val = e.target.value;
              if (!searchText && val) {
                // Starting search
                preSearchPageRef.current = page || 1;
                setPage(1);
              } else if (searchText && !val) {
                // Clearing search via backspace
                setPage(preSearchPageRef.current || 1);
              }
              setSearchText(val);
            }}
          />
          {searchText && (
            <FaTimes
              className="search-clear-icon"
              onClick={handleClearSearch}
            />
          )}
        </div>
      </div>
      <CommonTable
        columns={columns}
        data={data || []}
        pagecount={pagination}
        setPageno={setPage}
        pageno={page || 1}
      />
      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={confirmDelete}
        message="Are you sure you want to delete?"
      />
    </div>
  );
};

export default Admin;
